<div class="row gx-3 h-100">
  <div class="col">
    <div class="mb-1 fw-bold {{ priceTextClass() }} {{ priceColor() }}">{{ amount() | euroCurrency }}</div>
    <mwe-badge
      [iconClass]="invoiceStatusConfig().iconClass"
      [type]="invoiceStatusConfig().type"
      data-test="new-invoices-badge"
      emphasis="bold"
      size="sm"
    >
      @if (invoiceStatusConfig().saldo) {
        {{ invoiceStatusConfig().saldo | euroCurrency }}
      }
      {{ invoiceStatusConfig().key | translate }}
    </mwe-badge>
  </div>
</div>
